const angular = require('angular');
/**
 * Directive For Date time picker
 * 
 */
export default angular.module('nodeApp.datetimepicker', [])
    .directive('datetimepicker', ['$window', '$document', function ($window,$document) {

        return {
            require: '?ngModel',
            restrict: 'AE',
            scope   : {
              datetimepickerOptions: '&'
            },
            link: function (scope, elem, attrs,ngModelCtrl) {
              var passed_in_options = scope.datetimepickerOptions();
              var options = jQuery.extend({}, {}, passed_in_options);

              elem.on('dp.show', function (e) {
                var datepicker = $('body').find('.bootstrap-datetimepicker-widget:last'),
                    position = datepicker.offset(),
                    parent = datepicker.parent(),
                    parentPos = parent.offset(),
                    width = datepicker.width(),
                    parentWid = parent.width();
            
                // move datepicker to the exact same place it was but attached to body
                datepicker.appendTo('body');
                datepicker.css({
                    position: 'absolute',
                    top: position.top,
                    bottom: 'auto',
                    left: position.left,
                    right: 'auto',
                    zIndex: '99999999999'
                });
            
                // if datepicker is wider than the thing it is attached to then move it so the centers line up
                if (parentPos.left + parentWid < position.left + width) {
                    var newLeft = parentPos.left;
                    newLeft += parentWid / 2;
                    newLeft -= width / 2;
                    datepicker.css({left: newLeft});
                }
            })
              elem.on('dp.change', function (e) {
                if (ngModelCtrl) {
                  // $timeout(function () {
                    ngModelCtrl.$setViewValue(e.target.value);
                  //});
                }
              });
              elem.datetimepicker(options);
              //   {
              //   format:'DD-MMM-YY',
              //   showClear:true,
              //   showClose:true,
              //   showTodayButton:true,
              //   allowInputToggle:true,
              //   keepOpen:true,
              // }
              // );
      
                //Local event change
                elem.on('blur', function () {
                    /*// returns moments.js format object
                    scope.dateTime = new Date(elem.data("DateTimePicker").getDate().format());
                    // Global change propagation
      
                    $rootScope.$broadcast("emit:dateTimePicker", {
                        location: scope.location,
                        action: 'changed',
                        dateTime: scope.dateTime,
                        example: scope.useCurrent
                    });
                    scope.$apply();*/
                });
            }
        };
      }]).name;



// WEBPACK FOOTER //
// ./client/components/datetimePicker/datetimepicker.directive.ts